import { defineMessages } from 'react-intl';

import { SourceFilterValue } from './types';

export const sourceFilterMessages = defineMessages<SourceFilterValue>({
  all: {
    id: 'communityCatalog.sourceAll',
    defaultMessage: 'All sources',
  },
  system: {
    id: 'communityCatalog.sourceSystem',
    defaultMessage: 'Official',
  },
  community: {
    id: 'communityCatalog.sourceCommunity',
    defaultMessage: 'Community',
  },
});
